import { useAuth } from 'react-oidc-context';

const LoginPage = () => {
  const auth = useAuth();

  return auth.signinRedirect()
}

export default LoginPage;
